import { render, staticRenderFns } from "./GalleryBig.vue?vue&type=template&id=5b07f0d2&scoped=true&"
import script from "./GalleryBig.vue?vue&type=script&lang=js&"
export * from "./GalleryBig.vue?vue&type=script&lang=js&"
import style0 from "./GalleryBig.vue?vue&type=style&index=0&id=5b07f0d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b07f0d2",
  null
  
)

export default component.exports